<template>
  <div>
    <div v-if="currentContent === 'listOptions'">
      <base-card>
        <base-question text="O que você deseja editar?" class="mb_20" />

        <div>
          <div class="edit-option">
            <base-box sortBox class="box w-100">
              <p class="edit-option-text">Configurações básicas</p>
            </base-box>
            <base-button
              design="four"
              @click.prevent="goToStep('basicInfo')"
              class="edit-button mb_5"
            >
              <i class="fal fa-pen"></i>
            </base-button>
          </div>

          <div
            v-if="
              ((localTargetItem.type === 'pizza' ||
                localTargetItem.type === 'flavor' ||
                localTargetItem.type === 'step') &&
                localTargetItem.sizes.length > 1) ||
                (localTargetItem.type === 'drink' &&
                  targetItem.parent_ref.default_sizes)
            "
            class="edit-option"
          >
            <!-- produto pizzas com vários tamanhos, bebidas e outros de vários tamanhos-->
            <base-box sortBox class="box w-100">
              <p class="edit-option-text">Valores</p>
            </base-box>
            <base-button
              design="four"
              @click.prevent="goToStep('pricesOnSizes')"
              class="edit-button mb_5"
            >
              <i class="fal fa-pen"></i>
            </base-button>
          </div>

          <div
            v-if="
              (localTargetItem.type === 'category' &&
                localTargetItem.sizes.length > 1) ||
                (localTargetItem.type === 'drink' &&
                  !targetItem.parent_ref.default_sizes)
            "
            class="edit-option"
          >
            <!-- produto bebidas com tamanhos no produto, categoria outros e categoria pizza-->
            <base-box sortBox class="box w-100">
              <p class="edit-option-text">Tamanhos</p>
            </base-box>
            <base-button
              design="four"
              @click.prevent="goToStep('sizes')"
              class="edit-button mb_5"
            >
              <i class="fal fa-pen"></i>
            </base-button>
          </div>

          <div v-if="localTargetItem.type === 'step'" class="edit-option">
            <!-- produto outros -->
            <base-box sortBox class="box w-100">
              <p class="edit-option-text">Etapas</p>
            </base-box>
            <base-button
              design="four"
              @click.prevent="goToStep('steps')"
              class="edit-button mb_5"
            >
              <i class="fal fa-pen"></i>
            </base-button>
          </div>

          <div
            v-if="
              localTargetItem.type === 'category' &&
                localTargetItem.mode === 'pizza'
            "
            class="edit-option"
          >
            <!-- categoria pizza -->
            <base-box sortBox class="box w-100">
              <p
                v-if="localTargetItem.sizes.length === 1"
                class="edit-option-text"
              >
                Massa
              </p>
              <p v-else class="edit-option-text">Massas</p>
            </base-box>
            <base-button
              design="four"
              @click.prevent="goToStep('doughs')"
              class="edit-button mb_5"
            >
              <i class="fal fa-pen"></i>
            </base-button>
          </div>

          <div
            v-if="
              localTargetItem.type === 'category' &&
                localTargetItem.mode === 'pizza'
            "
            class="edit-option"
          >
            <!-- categoria pizza -->
            <base-box sortBox class="box w-100">
              <p class="edit-option-text">Borda</p>
            </base-box>
            <base-button
              design="four"
              @click.prevent="goToStep('edges')"
              class="edit-button mb_5"
            >
              <i class="fal fa-pen"></i>
            </base-button>
          </div>

          <div v-if="localTargetItem.type === 'category'" class="edit-option">
            <!-- categoria bebidas, categoria outros e categoria pizza -->
            <base-box sortBox class="box w-100">
              <p class="edit-option-text">Extra</p>
            </base-box>
            <base-button
              design="four"
              @click.prevent="goToStep('extras')"
              class="edit-button mb_5"
            >
              <i class="fal fa-pen"></i>
            </base-button>
          </div>

          <div class="edit-option">
            <base-box sortBox class="box w-100">
              <p class="edit-option-text">Outros</p>
            </base-box>
            <base-button
              design="four"
              @click.prevent="goToStep('others')"
              class="edit-button mb_5"
            >
              <i class="fal fa-pen"></i>
            </base-button>
          </div>

          <div class="mt_15">
            <base-button
              :text="
                localTargetItem.type === 'category'
                  ? 'Remover esta categoria'
                  : 'Remover este produto'
              "
              :design="'underline mb_15'"
              class="m_auto"
              @click.prevent="currentContent = 'deleteItem'"
            >
            </base-button>
          </div>
        </div>
      </base-card>
    </div>
    <div v-else-if="currentContent === 'edition'" class="fixed-content">
      <set-info
        v-if="itemToEdit === 'basicInfo'"
        :targetItem="localTargetItem"
        :externalEditMode="localTargetItem.type === 'category'"
      />
      <set-availability-step
        v-if="itemToEdit === 'others'"
        :targetItem="localTargetItem"
      />
      <set-prices-on-sizes-step
        v-if="itemToEdit === 'pricesOnSizes'"
        :targetItem="localTargetItem"
      />

      <set-stages-step
        v-if="itemToEdit === 'steps'"
        ref="setStages"
        :targetItem="localTargetItem"
        :originCatalog="originCatalog"
      />

      <set-sizes-on-drink-step
        v-if="itemToEdit === 'sizes' && localTargetItem.type === 'drink'"
        ref="setSizesOnDrink"
        :targetItem="localTargetItem"
        :externalEditMode="true"
      />

      <set-sizes-step
        v-if="itemToEdit === 'sizes' && localTargetItem.type !== 'drink'"
        :targetItem="localTargetItem"
      />

      <set-extra-ingredients-step
        v-if="itemToEdit === 'extras'"
        :targetItem="localTargetItem"
      />

      <set-edges-step
        v-if="itemToEdit === 'edges'"
        :targetItem="localTargetItem"
      />

      <set-doughs-step
        v-if="itemToEdit === 'doughs'"
        :targetItem="localTargetItem"
      />

      <div class="footer">
        <div class="footer-container">
          <base-button
            design="four"
            class="mr_5 big footer-button"
            @click="currentContent = 'listOptions'"
          >
            <span>Cancelar</span>
          </base-button>

          <base-button class="ml_10 big footer-button" @click="save()">
            <span>Salvar informações</span>
          </base-button>
        </div>
      </div>
    </div>
    <div v-else class="fixed-content">
      <base-card>
        <p v-if="localTargetItem.type === 'category'" class="delete-text">
          Ao excluir a categoria
          <strong>"{{ localTargetItem.name }}"</strong> você perderá todas as
          configurações, e produtos cadastrados nela. Não sendo possível
          recuperá-los após isso.
        </p>
        <p v-else class="delete-text">
          Ao excluir o produto
          <strong>"{{ localTargetItem.name }}"</strong> você perderá todas as
          configurações. Não sendo possível recuperá-las após isso.
        </p>
      </base-card>
      <div class="footer">
        <div class="footer-container">
          <base-button
            design="four"
            class="mr_5 big footer-button"
            @click="currentContent = 'listOptions'"
          >
            <span>Cancelar</span>
          </base-button>

          <base-button class="ml_10 big footer-button" @click="deleteItem()">
            <span>Confirmar</span>
          </base-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCard from '@/components/Card';
import BaseQuestion from '@/components/Question';
import BaseBox from '@/components/Box';
import BaseButton from '@/components/Button';
import SetInfo from '@/containers/Catalog/ProductSteps/SetInfo.vue';
import SetAvailabilityStep from '@/containers/Catalog/CategorySteps/SetAvailabilityStep.vue';
import SetPricesOnSizesStep from '@/containers/Catalog/ProductSteps/SetPricesOnSizesStep.vue';
import SetStagesStep from '@/containers/Catalog/ProductSteps/SetStagesStep.vue';
import SetSizesOnDrinkStep from '@/containers/Catalog/ProductSteps/SetSizesOnDrinkStep.vue';
import SetExtraIngredientsStep from '@/containers/Catalog/CategorySteps/SetExtraIngredientsStep.vue';
import SetDoughsStep from '@/containers/Catalog/CategorySteps/SetDoughsStep.vue';
import SetEdgesStep from '@/containers/Catalog/CategorySteps/SetEdgesStep.vue';
import SetSizesStep from '@/containers/Catalog/CategorySteps/SetSizesStep.vue';
// libs
import Builder from 'easyjs/lib/Schema/Components/Builder';

export default {
  components: {
    BaseCard,
    BaseQuestion,
    BaseBox,
    BaseButton,
    SetInfo,
    SetAvailabilityStep,
    SetPricesOnSizesStep,
    SetStagesStep,
    SetSizesOnDrinkStep,
    SetExtraIngredientsStep,
    SetDoughsStep,
    SetEdgesStep,
    SetSizesStep,
  },
  data() {
    return {
      currentContent: 'listOptions',
      localTargetItem: Builder.factory('Base'),
      itemToEdit: null,
    };
  },
  props: {
    targetItem: { default: {} },
    originCatalog: { default: {} },
    saveItem: { type: Function },
  },
  mounted() {
    this.localTargetItem = Builder.mountSchema(
      JSON.parse(JSON.stringify(this.targetItem))
    );
  },
  methods: {
    goToStep(content) {
      this.itemToEdit = content;
      this.currentContent = 'edition';
    },
    save() {
      Object.assign(this.targetItem, this.localTargetItem);
      if (this.$refs.setSizesOnDrink) this.$refs.setSizesOnDrink.saveSize();

      if (this.$refs.setStages) {
        if (!this.$refs.setStages.editMode.status) {
          if (!this.$refs.setStages.addStep()) return;
        } else {
          if (!this.$refs.setStages.saveStep()) return;
        }
      }
      
      this.$emit('saveItem', this.targetItem);
    },
    deleteItem(id = null, showConfirm = true) {
      if (id) {
        const deleteFn = () => {
          this.targetItem
            .getItemsByParam('_id', id)
            .forEach(i => Vue.set(i, 'delete', true));
          //Remove todos os tamanhos que foram excluídos
          let catalog = Builder.factory('Catalog');
          catalog.addItems(this.targetItem);
          Builder.executeOnSchema(catalog, item => {
            if (item.sizes.length > 0) {
              Vue.set(
                item,
                'sizes',
                item.sizes.filter(s => !s.delete)
              );
            }
          });
        };

        if (showConfirm) {
          confirm(StringLanguage.confirmDelete, res => res && deleteFn());
        } else {
          deleteFn();
        }
      } else {
        this.targetItem.delete = true;
        this.$emit('saveItem', this.targetItem);
      }
    },
  },
};
</script>

<style scoped>
.edit-option {
  display: flex;
  align-items: center;
  margin-bottom: 5px;
}
.box {
  display: flex;
  align-items: center;
}
.edit-option-text {
  font-size: 1.2em;
}
.edit-button {
  height: 42.5px;
  border-color: #99999980;
  margin-left: 15px;
}
.edit-button i {
  font-size: 16px;
}
.fixed-content {
  min-height: calc(100vh - 77px);
  padding-bottom: 77px;
}
.delete-text {
  font-size: 1.4em;
  color: #cccccc;
}
.delete-text strong {
  color: #ffffff;
  font-weight: bold;
}
.footer {
  background: var(--box);
  width: calc(100% + 30px);
  box-shadow: 0px 0px 6px #00000029;
  padding: 20px 15px;
  z-index: 1;
  position: absolute;
  bottom: 0;
  left: -15px;
}
.footer-container {
  display: flex;
  align-items: center;
  padding: 0 15px;
}
.footer-button {
  flex: 1;
}
</style>
